import { IS_CLINICAL_TASKS_ENABLED } from '@/components/constants/flags';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { ConsultNoteStatus } from '@heidi/schema/ml-scribe';
import { useQuerySessionById } from '@heidi/session/data';
import { isEmpty } from 'lodash-es';

export const useClinicalTasksPanelAvailability = (sessionId: string) => {
  const isMobile = useIsMobile();

  const { data: session } = useQuerySessionById({
    sessionId,
    select: (data) => {
      if (!data) return undefined;
      return {
        consult_note: data.consult_note,
        generate_output_without_recording: data.generate_output_without_recording,
      };
    },
  });

  const sessionAvailable =
    !session?.generate_output_without_recording &&
    !isEmpty(session?.consult_note.result) &&
    session?.consult_note.status === ConsultNoteStatus.COMPLETED;

  const shouldShowClinicalTasksPanel =
    IS_CLINICAL_TASKS_ENABLED() && sessionAvailable && !isMobile;

  return {
    session,
    sessionAvailable,
    shouldShowClinicalTasksPanel,
  };
};
